import React, { Component } from 'react'
import { batch, connect } from 'react-redux'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  ListItem,
  Paper,
  Switch,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Tabs,
  Tab,
  Tooltip,
  InputAdornment,
  Input,
} from '@material-ui/core'
import { getListBatches, getListProductQuantityInfo } from '../../../actions/masterCatalog'
//import { sortInventories } from "../../utils/array";
import { PreviousPage, NextPage } from '../../../assets'
import {
  fetchInventories,
  loadProductsById,
  getProductSell,
  getProduct,
} from '../../../actions/inventory'
//import { getShopList } from '../../../actions/shop';
import moment from 'moment'
import { toCurrencyLocale, addSearchItems, manualSearch } from '../../../utils/common'
import { checkAccessToMaster, checkAccessToShop } from '../../../utils/api'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
class InventoryBatchesModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openModal: false,
      activeTab: 'inventory',
      productsList: [],
      positionChildProduct: 0,
      orphanProduct: {},
      positionOrphanProduct: 0,
      nameShopSelected: '',
      selectedChildProduct: '',
      currentChildProduct: {},
      term: '',
      productSellInfo: null,
    }
  }

  componentWillMount() {
    //this.props.dispatch(getShopList());
  }

  openModal = async () => {
    const { data = {}, masterCatalogReducer = {}, shopReducer = {} } = this.props

    const childProductId = data.id
    const shopId = data.shopId

    const findShop =
      shopReducer &&
      shopReducer.shopsList &&
      shopReducer.shopsList.values &&
      shopReducer.shopsList.values.find((shop) => {
        return shop.id === data.shopId
      })

    const productData = await this.props.dispatch(getProduct(childProductId))

    const masterProduct =
      masterCatalogReducer &&
      masterCatalogReducer.products &&
      masterCatalogReducer.products.find((product) => {
        return product.master && product.master.id ? product.master.id === data.masterId : ''
      })

    const childProductsList =
      masterProduct.master &&
      masterProduct.master.children &&
      masterProduct.master.children.map((child) => child)

    let positionChildProduct = 0
    masterProduct.master &&
      masterProduct.master.children &&
      masterProduct.master.children.map((child, index) => {
        if (child.id === data.id) {
          positionChildProduct = index
        }
      })

    await this.props.dispatch(loadProductsById(childProductId))
    await this.props.dispatch(fetchInventories(shopId))
    await this.props.dispatch(getListBatches(childProductId, shopId))
    await this.props.dispatch(getListProductQuantityInfo(childProductId))

    await this.props.dispatch(getProductSell(childProductId)).then((res) => {
      this.setState({ productSellInfo: res })
    })

    this.setState({
      openModal: true,
      productsList: childProductsList,
      positionChildProduct: positionChildProduct,
      selectedChildProduct: childProductId,
      nameShopSelected: findShop.name,
      currentChildProduct: productData ? { ...productData, ...data } : data,
    })
  }

  openModalOrphan = async () => {
    const { data = {}, masterCatalogReducer = {}, shopReducer = {} } = this.props

    const childProductId = data.id
    const shopId = data.shopId

    const findShop =
      shopReducer &&
      shopReducer.shopsList &&
      shopReducer.shopsList.values &&
      shopReducer.shopsList.values.find((shop) => {
        return shop.id === data.shopId
      })

    const productData = await this.props.dispatch(getProduct(childProductId))
    const orphanProduct =
      masterCatalogReducer &&
      masterCatalogReducer.products &&
      masterCatalogReducer.products.map((product) => product.orphan)

    let positionOrphanProduct = 0

    this.setState({
      openModal: true,
      orphanProduct: orphanProduct,
      positionOrphanProduct: positionOrphanProduct,
      selectedChildProduct: childProductId,
      nameShopSelected: findShop.name,
      currentChildProduct: productData ? { ...productData, ...data } : data,
    })

    this.props.dispatch(loadProductsById(childProductId))
    this.props.dispatch(fetchInventories(shopId))
    this.props.dispatch(getListBatches(childProductId, shopId))
    this.props.dispatch(getListProductQuantityInfo(childProductId))

    await this.props.dispatch(getProductSell(childProductId)).then((res) => {
      this.setState({ productSellInfo: res })
    })
  }

  handleClose = () => {
    this.setState({
      openModal: false,
    })
  }

  changeActiveTab = (e, value) => {
    this.setState({
      activeTab: value,
      //term: "",
    })
  }

  totalInventory = () => {
    const { masterCatalogReducer = {} } = this.props
    const { currentChildProduct } = this.state

    const totalInventory =
      masterCatalogReducer &&
      masterCatalogReducer.products &&
      masterCatalogReducer.products.find((product) => {
        return (
          product &&
          product.master &&
          product.master.totalInventory === currentChildProduct.totalInventory
        )
      })
    return totalInventory ? totalInventory.master.totalInventory : null
  }

  changeChildProduct = async (subIndex = 0) => {
    const { masterCatalogReducer = {}, shopReducer = {} } = this.props
    const { currentChildProduct = {} } = this.state

    const masterProduct =
      masterCatalogReducer &&
      masterCatalogReducer.products &&
      masterCatalogReducer.products.find((product) => {
        return product.master && product.master.id
          ? product.master.id === currentChildProduct.masterId
          : ''
      })

    const childProductsList =
      masterProduct.master &&
      masterProduct.master.children &&
      masterProduct.master.children.map((child) => child)

    if (currentChildProduct) {
      const id = currentChildProduct.id
      let newChildProductIndex = 0
      let newChildProduct = null
      let newShopId = ''

      masterProduct.master &&
        masterProduct.master.children.map(async (child, index) => {
          if (child.id === id) {
            newChildProductIndex = index + subIndex
            newChildProduct = masterProduct.master.children[newChildProductIndex]
            newShopId = newChildProduct.shopId
            const findShop =
              shopReducer &&
              shopReducer.shopsList &&
              shopReducer.shopsList.values &&
              shopReducer.shopsList.values.find((shop) => shop.id === newShopId)

            await this.props.dispatch(fetchInventories(newShopId))
            await this.props.dispatch(loadProductsById(newChildProduct.id))
            await this.props.dispatch(getListProductQuantityInfo(newChildProduct.id))
            await this.props.dispatch(getListBatches(newChildProduct.id, newShopId))

            await this.props.dispatch(getProductSell(newChildProduct.id)).then((res) => {
              this.setState({ productSellInfo: res })
            })

            this.setState({
              productsList: childProductsList,
              positionChildProduct: newChildProductIndex,
              selectedChildProduct: newChildProduct.id,
              currentChildProduct: newChildProduct,
              nameShopSelected: findShop.name,
            })
          }
        })
    }
  }

  onSearchModal = (value, type) => {
    if (type == 'term') {
      this.setState({
        term: value,
      })
    }
  }

  render() {
    const { data } = this.props
    const {
      openModal = false,
      activeTab = 'inventory',
      productsList = [],
      positionChildProduct = 0,
      nameShopSelected = '',
      term = '',
      productSellInfo,
      currentChildProduct = {},
    } = this.state
    const { inventories = {} } = this.props.inventoryReducer
    const { batches = [] } = this.props.batchReducer
    let totalRemaining = data.totalRemaining
      ? data.totalRemaining
      : data.quantities
      ? data.quantities.reduce((total, q) => total + q.quantity, 0)
      : null
    const filterInventory = manualSearch(term, inventories.values)
    const filterBatch = manualSearch(term, batches)
    const accessToMaster = checkAccessToMaster('category')
    const accesToShop = checkAccessToShop(data && data.shop && data.shop.id, 'category')
    const activeShop = data && data.shop && data.shop.active
    const deletedShop = data && data.shop && data.shop.deleted
    return (
      <div className="align-left-item-column">
        {!(accessToMaster || accesToShop) ? (
          <div>
            {!data.masterId && data.childProduct != false ? (
              <span>{this.totalInventory()}</span>
            ) : null}

            {data.masterId ? <span>{totalRemaining}</span> : null}

            {!data.masterId && data.childProduct === false ? <span>{totalRemaining}</span> : null}
          </div>
        ) : (
          <div>
            {!data.masterId && data.childProduct != false ? (
              <span style={{ color: 'black' }}>{this.totalInventory()}</span>
            ) : null}

            {data.masterId ? (
              <span
                hidden={
                  !(accessToMaster || accesToShop) ||
                  ((!activeShop || deletedShop) && !data.children)
                }
                onClick={this.openModal}
                className="button-to-edit-image"
              >
                {totalRemaining}
              </span>
            ) : null}

            {!data.masterId && data.childProduct === false ? (
              <span onClick={this.openModalOrphan} className="button-to-edit-image">
                {totalRemaining}
              </span>
            ) : null}

            {openModal && (
              <Dialog open={openModal} onClose={this.handleClose}>
                <DialogTitle id="scroll-dialog-title">
                  Inventory & Batches
                  <div style={{ float: 'right', alignItems: 'flex-end', cursor: 'pointer' }}>
                    <CloseIcon onClick={this.handleClose} />
                  </div>
                  <br />
                  {activeTab == 'batches' && (
                    <Tooltip title={'Calculated based on the last 7 days'} placement="top">
                      <div style={{ float: 'right' }} className="spacing-between-fields">
                        <span className="space-between-field-and-label">
                          Sell Through Rate:{' '}
                          <b>{productSellInfo ? productSellInfo.avgSoldQuantity : 0}</b>
                        </span>
                        <span>
                          Days Remaining:{' '}
                          <b>{productSellInfo ? productSellInfo.daysRemainingInInventory : 0}</b>
                        </span>
                      </div>
                    </Tooltip>
                  )}
                  <br />
                  <div style={{ display: 'flex' }}>
                    <p>{nameShopSelected}</p>

                    {positionChildProduct > 0 &&
                    (currentChildProduct.children || currentChildProduct.masterId) ? (
                      <Tooltip title={'Previous Store'}>
                        <img
                          src={`${PreviousPage}`}
                          onClick={() => {
                            this.changeChildProduct(-1)
                          }}
                          style={{
                            color: 'primary',
                            cursor: 'pointer',
                            marginLeft: '1em',
                            marginRight: '1em',
                          }}
                        />
                      </Tooltip>
                    ) : null}

                    {positionChildProduct + 1 !== productsList.length &&
                    (currentChildProduct.children || currentChildProduct.masterId) ? (
                      <Tooltip title={'Next Store'}>
                        <img
                          src={`${NextPage}`}
                          onClick={() => {
                            this.changeChildProduct(1)
                          }}
                          style={{
                            color: 'primary',
                            cursor: 'pointer',
                            marginLeft: '1em',
                            marginRight: '0.15em',
                          }}
                        />
                      </Tooltip>
                    ) : null}
                  </div>
                </DialogTitle>

                <DialogContent>
                  <Grid container alignItems="flex-start" flexDirection="row">
                    <div style={{ display: 'flex' }}>
                      <Grid item xs={7}>
                        <Tabs
                          value={activeTab}
                          indicatorColor="primary"
                          onChange={this.changeActiveTab}
                          className="margin-bottom-small"
                        >
                          <Tab label="Inventory" value="inventory" />
                          <Tab label="Batches" value="batches" />
                        </Tabs>
                      </Grid>

                      <Grid container direction="row">
                        <Input
                          placeholder="Search"
                          editMode={true}
                          material={false}
                          style={{
                            width: '100%',
                            height: '60%',
                            paddingTop: '6px',
                            marginLeft: '7px',
                          }}
                          startAdornment={
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          }
                          onChange={(event) => {
                            this.onSearchModal(event.target.value, 'term')
                          }}
                        />
                      </Grid>
                    </div>
                  </Grid>

                  {activeTab === 'inventory' ? (
                    <Table responsive striped>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ color: 'black' }}>Inventory</TableCell>
                          <TableCell style={{ color: 'black' }}>Qty</TableCell>
                          <TableCell style={{ color: 'black', width: '250px' }}>Notes</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {term
                          ? filterInventory.map((filtInvent, index) => {
                              if (!currentChildProduct || !currentChildProduct.quantities) {
                                return null
                              }
                              let pq = currentChildProduct.quantities.find(
                                (pq) => pq.inventoryId === filtInvent.id,
                              )
                              var quantity = 0
                              if (pq) {
                                quantity = pq.quantity
                              }
                              return (
                                <TableRow key={index}>
                                  <TableCell component="th" scope="row">
                                    {filtInvent ? filtInvent.name : null}
                                  </TableCell>
                                  <TableCell align="right">{quantity ? quantity : 0}</TableCell>
                                  <TableCell align="right">
                                    {currentChildProduct && currentChildProduct.notes
                                      ? currentChildProduct.notes
                                      : null}
                                  </TableCell>
                                </TableRow>
                              )
                            })
                          : inventories &&
                            inventories.values &&
                            inventories.values.map((inventory, index) => {
                              if (!currentChildProduct || !currentChildProduct.quantities) {
                                return null
                              }
                              let pq = currentChildProduct.quantities.find(
                                (pq) => pq.inventoryId === inventory.id,
                              )
                              var quantity = 0
                              if (pq) {
                                quantity = pq.quantity
                              }

                              return (
                                <TableRow key={index}>
                                  <TableCell component="th" scope="row">
                                    {inventory ? inventory.name : null}
                                  </TableCell>
                                  <TableCell align="right">{quantity ? quantity : 0}</TableCell>
                                  <TableCell align="right">
                                    {currentChildProduct && currentChildProduct.notes
                                      ? currentChildProduct.notes
                                      : null}
                                  </TableCell>
                                </TableRow>
                              )
                            })}

                        {inventories && inventories.length === 0 && (
                          <tr>
                            <td
                              colSpan={12}
                              style={{
                                fontSize: '15px',
                                textAlign: 'center',
                                paddingBottom: '40px',
                              }}
                            >
                              No data to show
                            </td>
                          </tr>
                        )}
                      </TableBody>
                    </Table>
                  ) : (
                    <Table responsive striped>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ color: 'black' }}>Batch ID</TableCell>
                          <TableCell style={{ color: 'black' }}>Unique #</TableCell>
                          <TableCell style={{ color: 'black' }}>Purchase Qty</TableCell>
                          <TableCell style={{ color: 'black' }}>Current Qty</TableCell>
                          <TableCell style={{ color: 'black' }}>Unit Cost</TableCell>
                          <TableCell style={{ color: 'black' }}>Price</TableCell>
                          <TableCell style={{ color: 'black' }}>Batch Created</TableCell>
                          <TableCell style={{ color: 'black' }}>Batch Received</TableCell>
                          <TableCell style={{ color: 'black' }}>Expires on</TableCell>
                          <TableCell style={{ color: 'black' }}>THC %</TableCell>
                          <TableCell style={{ color: 'black' }}>Age</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {term
                          ? filterBatch.map((filtBatch, index) => {
                              const currentQuantity =
                                (filtBatch.batchQuantityMap &&
                                  Object.keys(filtBatch.batchQuantityMap).length &&
                                  Object.keys(filtBatch.batchQuantityMap)
                                    .map((inventoryId) => filtBatch.batchQuantityMap[inventoryId])
                                    .reduce((elem1, elem2) => elem1 + elem2)) ||
                                0
                              const data = { ...filtBatch, currentQuantity }

                              const unityCost =
                                (data.costPerUnit && toCurrencyLocale(Number(data.costPerUnit))) ||
                                ''
                              const price = (data.cost && toCurrencyLocale(Number(data.cost))) || ''
                              const batchCreated =
                                (data.purchasedDate &&
                                  moment(new Date(data.purchasedDate)).format('MM/DD/YYYY')) ||
                                ''
                              const batchReceived =
                                (data.receiveDate &&
                                  moment(new Date(data.receiveDate)).format('MM/DD/YYYY')) ||
                                ''
                              const exspiresOn =
                                (data.expirationDate &&
                                  moment(new Date(data.expirationDate)).format('MM/DD/YYYY')) ||
                                ''

                              return (
                                <TableRow key={index}>
                                  <TableCell component="th" scope="row">
                                    {data && data.trackHarvestBatch ? data.trackHarvestBatch : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.sku ? data.sku : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.quantity ? data.quantity : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.liveQuantity ? data.liveQuantity : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {unityCost ? unityCost : null}
                                  </TableCell>
                                  <TableCell align="right">{price ? price : null}</TableCell>
                                  <TableCell align="right">
                                    {batchCreated ? batchCreated : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {batchReceived ? batchReceived : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {exspiresOn ? exspiresOn : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.thc ? data.thc : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {/* {data && data.quantity ? data.quantity : null} */}
                                  </TableCell>
                                </TableRow>
                              )
                            })
                          : batches &&
                            batches.length &&
                            batches.map((batch, index) => {
                              const currentQuantity =
                                (batch.batchQuantityMap &&
                                  Object.keys(batch.batchQuantityMap).length &&
                                  Object.keys(batch.batchQuantityMap)
                                    .map((inventoryId) => batch.batchQuantityMap[inventoryId])
                                    .reduce((elem1, elem2) => elem1 + elem2)) ||
                                0
                              const data = { ...batch, currentQuantity }

                              const unityCost =
                                (data.costPerUnit && toCurrencyLocale(Number(data.costPerUnit))) ||
                                ''
                              const price = (data.cost && toCurrencyLocale(Number(data.cost))) || ''
                              const batchCreated =
                                (data.purchasedDate &&
                                  moment(new Date(data.purchasedDate)).format('MM/DD/YYYY')) ||
                                ''
                              const batchReceived =
                                (data.receiveDate &&
                                  moment(new Date(data.receiveDate)).format('MM/DD/YYYY')) ||
                                ''
                              const exspiresOn =
                                (data.expirationDate &&
                                  moment(new Date(data.expirationDate)).format('MM/DD/YYYY')) ||
                                ''

                              return (
                                <TableRow key={index}>
                                  <TableCell component="th" scope="row">
                                    {data && data.trackHarvestBatch ? data.trackHarvestBatch : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.sku ? data.sku : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.quantity ? data.quantity : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.liveQuantity ? data.liveQuantity : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {unityCost ? unityCost : null}
                                  </TableCell>
                                  <TableCell align="right">{price ? price : null}</TableCell>
                                  <TableCell align="right">
                                    {batchCreated ? batchCreated : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {batchReceived ? batchReceived : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {exspiresOn ? exspiresOn : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {data && data.thc ? data.thc : null}
                                  </TableCell>
                                  <TableCell align="right">
                                    {/* {data && data.quantity ? data.quantity : null} */}
                                  </TableCell>
                                </TableRow>
                              )
                            })}

                        {batches && batches.length === 0 && (
                          <tr>
                            <td
                              colSpan={12}
                              style={{
                                fontSize: '15px',
                                textAlign: 'center',
                                paddingBottom: '40px',
                              }}
                            >
                              No data to show
                            </td>
                          </tr>
                        )}
                      </TableBody>
                    </Table>
                  )}
                </DialogContent>

                <DialogActions></DialogActions>
              </Dialog>
            )}
          </div>
        )}
      </div>
    )
  }
}

const InventoryBatchesModalWithTitle = ContainerWithTitle(InventoryBatchesModal, 'Master Products')

export const InventoryBatchesModalConnect = connect(
  ({ dispatch, masterCatalogReducer, inventoryReducer, shopReducer, batchReducer }) => ({
    dispatch,
    masterCatalogReducer,
    inventoryReducer,
    shopReducer,
    batchReducer,
  }),
)(InventoryBatchesModalWithTitle)



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Fields/InventoryBatchesModal.js